export default __webpack_public_path__ + "static/media/Logo2.eefafc83.svg";